module.exports = __webpack_public_path__ + "static/bondetous-pres1-635c08733923f043f3fa76455db4b490.png";